import { Usage } from '@activepieces/shared'

import { api } from '@/lib/api'

export const usageApi = {
  get(): Promise<Usage> {
    return api.get<Usage>('/v1/usage')
  },
}
